'server-only';

import { environments } from '@/constants/environments';

export const isLocal = process.env.NODE_ENV === environments.development;

export const enableLocalMocks = isLocal && process.env.ENABLE_LOCAL_MOCKS === 'true';
